export default __webpack_public_path__ + "static/media/formImageOne.ae5cf1b8.jpg";